export const PRECHAT_CAPTURE_MESSAGE_DELAY_MS = 2000;

export const PRECHAT_CAPTURE_ERROR = 'PRECHAT_CAPTURE_ERROR';

export const PRECHAT_CAPTURE_TEMPLATES = {
    NameEmail: 'name-email',
};
